import * as React from 'react'

function SvgMail(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_8636_484127)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 3.5H15C15.825 3.5 16.5 4.175 16.5 5V14C16.5 14.825 15.825 15.5 15 15.5H3C2.175 15.5 1.5 14.825 1.5 14V5C1.5 4.175 2.175 3.5 3 3.5Z"
          stroke="#00D37E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5 5L9 10.25L1.5 5"
          stroke="#00D37E"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_8636_484127">
          <rect
            width="16.5"
            height="13.5"
            fill="white"
            transform="translate(0.75 2.75)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgMail
